import { Chip, Grid } from "@material-ui/core";
import { AddAlert, TableChart } from "@material-ui/icons";
import * as React from "react";
import { RadioButtonGroupInput, SelectInput, TextInput } from "react-admin";
import { Form } from "react-final-form";
import { ExperienceNoteType } from "../../../../../src/Enums/ExperienceNoteType";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import { SectionTitle } from "../../../../Components/SectionTitle";
import { Separator } from "../../../../Components/Separator";
import { ServiceableTransactionTypeKey } from "../../../../Constants/Constant";
import { GetCarrierType } from "../../../../Enums/CarrierType";
import { ShippingType } from "../../../../Enums/ShippingType";
import { ShippingTypeChoices } from "../../Constant/Source";
import ExperienceSoftWarningDialog from "../ExperiencePopup";
import ServiceableStatusChip from "../Statu/ServiceableStatusChip";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const ServiceableView = props => {
  function isReceiving() {
    return props?.requestDetail?.transactionType === ServiceableTransactionTypeKey;
  }

  return (
    <>
      <Form
        onSubmit={e => alert("deneme")}
        render={({ handleSubmit, form, values }) => (
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <Separator />
                <Grid {...gridContainerProps}>
                  {isReceiving() && (
                    <Chip
                      key={999999}
                      color="primary"
                      variant="outlined"
                      label={props?.requestDetail?.transactionType}
                      icon={<TableChart />}
                    />
                  )}
                  <SectionTitle label="Serviceable Info" />
                  <ServiceableStatusChip serviceable={props.serviceable} />
                </Grid>
                <Separator />
                <Grid {...gridContainerProps}>
                  <Grid item xs={12} sm={5}>
                    <RadioButtonGroupInput
                      source="shippingTypeEnum"
                      label="Shipping Type"
                      defaultValue={
                        props.serviceable?.shippingTypeEnum === null ||
                        props.serviceable?.shippingTypeEnum === ShippingType.None
                          ? ShippingType.RBH
                          : props.serviceable?.shippingTypeEnum
                      }
                      fullWidth
                      choices={ShippingTypeChoices}
                      variant="outlined"
                    />
                    <TextInput
                      source="serviceablePn"
                      label="PN"
                      fullWidth
                      resettable
                      variant="outlined"
                      defaultValue={props.serviceable?.pn}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <TextInput
                      source="serviceableAwb"
                      label="AWB No"
                      fullWidth
                      resettable
                      variant="outlined"
                      defaultValue={props.serviceable?.awb}
                      disabled
                    />
                  </Grid>
                </Grid>
                <Grid {...gridContainerProps}>
                  <Grid item xs={12} sm={5}>
                    <TextInput
                      source="serviceableFlightNo"
                      label="Flight No"
                      fullWidth
                      resettable
                      variant="outlined"
                      defaultValue={props.serviceable?.flightNo}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <TextInput
                      source="serviceableSn"
                      label="SN"
                      fullWidth
                      resettable
                      variant="outlined"
                      defaultValue={props.serviceable?.sn}
                      disabled
                    />
                  </Grid>
                </Grid>
                <Grid {...gridContainerProps}>
                  <Grid item xs={12} sm={5}></Grid>
                  <Grid item xs={12} sm={5} />
                </Grid>
                <Grid {...gridContainerProps}>
                  <Grid item xs={12} sm={5}>
                    <SelectInput
                      source="serviceableCarrierEnum"
                      label="Carrier"
                      choices={GetCarrierType}
                      optionText="Description"
                      optionValue="Value"
                      fullWidth
                      variant="outlined"
                      defaultValue={props.serviceable?.carrierEnum}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <CustomDatetime
                      fullWidth
                      source="serviceableFlightDate"
                      label="Flight Date"
                      inputVariant={"dialog"}
                      variant="outlined"
                      showTime
                      defaultValue={props.serviceable?.flightDate}
                      disabled
                    />
                  </Grid>
                </Grid>
                <Grid {...gridContainerProps}>
                  <Grid item xs={12} sm={5}></Grid>
                  <Grid item xs={12} sm={5}>
                    <CustomDatetime
                      fullWidth
                      source="serviceableEstimatedDeliveryDate"
                      label="Estimated Delivery Date"
                      inputVariant={"dialog"}
                      variant="outlined"
                      showTime
                      defaultValue={props.serviceable?.estimatedDeliveryDate}
                      disabled
                    />
                  </Grid>
                </Grid>
                {isReceiving() && (
                  <Chip
                    key={999999}
                    color="primary"
                    variant="outlined"
                    label="Core RN dönüşüdür, çıkış RN yapılmalıdır!"
                    icon={<AddAlert />}
                  />
                )}
                <Separator />
              </Grid>
            </Grid>
          </form>
        )}
      />
      <ExperienceSoftWarningDialog data={props?.experienceData} type={ExperienceNoteType.Serviceable} />
    </>
  );
};

const RbhRequestServiceableView = props => {
  return (
    <ServiceableView
      experienceData={props.experienceData}
      serviceable={props.serviceable}
      requestDetail={props.requestDetailData}
    />
  );
};

export default RbhRequestServiceableView;
